// 按照比例进行移动
const getScaleValue = (fixedValue, baseScreenWidth = 1920) => {
    const screenWidth = window.innerWidth; // 当前屏幕宽度
    return (fixedValue / baseScreenWidth) * screenWidth;
};

export {getScaleValue}